import {nanoid} from 'nanoid';

import {logTmrEvent} from '@web-catalog/utils/analytics';

type LogSearchResultsClickProps = {
  query: string;
  position: number;
  appId: string;
  currentCategory: string;
};

export const log = {
  appsAppSelect: () => {
    logTmrEvent({
      logEvent: 'AppsWithPagination.app.select',
      params: {
        screen_name: 'apps',
      },
    });
  },

  appCategoryAppSelect: (appCategoryName: string) => {
    logTmrEvent({
      logEvent: 'appCategory.app.select',
      params: {
        screen_name: 'appCategory',
        app_category_name: appCategoryName,
      },
    });
  },

  gamesGameSelect: () => {
    logTmrEvent({
      logEvent: 'games.game.select',
      params: {
        screen_name: 'games',
      },
    });
  },

  gameCategoryGameSelect: (appCategoryName: string) => {
    logTmrEvent({
      logEvent: 'gameCategory.game.select',
      params: {
        screen_name: 'gameCategory',
        app_category_name: appCategoryName,
      },
    });
  },

  searchResultsClick: ({
    query,
    position,
    appId,
    currentCategory,
  }: LogSearchResultsClickProps) => {
    logTmrEvent({
      logEvent: 'searchResults.click',
      params: {
        app_category_name: currentCategory,
        q_id: nanoid(),
        query,
        position,
        app_id: appId,
      },
    });
  },
};
